import Eyebrow from "@/components/zeblan/Eyebrow";
import Reveal from "@/components/zeblan/Reveal";

const services = [
  {
    n: "01",
    title: "Custom AI agent implementation",
    body: "This is what we do best. We design, build, and integrate AI agents tailored to your workflows. Every project starts by determining the exact return on investment, so the tool is proven to save time and money, then we build to your precise specifications.",
    dark: true,
    fullWidth: true,
    pill: "Our core focus",
  },
  {
    n: "02",
    title: "Localized hosting & security",
    body: "Worried about putting company data into a public AI tool? We offer local, private hosting for your models. All the brainpower of advanced AI, with the security of an offline server.",
  },
  {
    n: "03",
    title: "Long-term aftercare & support",
    body: "We don't hand over the keys and walk away. We provide ongoing support, system updates, and personal check-ins so your tools keep running smoothly as your business grows.",
  },
  {
    n: "04",
    title: "Custom AI consulting",
    body: "Have an idea that doesn't fit into a neat box? Just ask. With our deep technical background, if you can imagine it, we can likely build it.",
    fullWidth: true,
  },
];

export default function Services() {
  return (
    <section id="services" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-2xl">
          <Eyebrow>Our Services</Eyebrow>
          <h2 className="mt-6 text-navy font-extrabold tracking-tightish" style={{ fontSize: "clamp(30px,4vw,46px)" }}>
            Custom AI in your <span className="font-display italic font-medium text-blue">daily operations</span>
          </h2>
          <p className="mt-5 text-slate text-[17px] leading-relaxed">
            Safe, secure, and highly effective, built around the way your business actually runs.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-5">
          {services.map((s, i) => {
            const span = s.fullWidth ? "md:col-span-2" : "";
            if (s.dark) {
              return (
                <Reveal key={s.n} delay={i * 80} className={span}>
                  <article
                    className="relative overflow-hidden rounded-2xl p-9 lg:p-12 text-white border border-white/5 h-full"
                    style={{ background: "linear-gradient(135deg, #0A1328 0%, #11214b 100%)" }}
                    data-testid={`service-card-${s.n}`}
                  >
                    {s.pill && (
                      <span className="inline-block text-[11px] font-bold uppercase tracking-[0.22em] text-teal border border-teal/40 rounded-full px-3 py-1">
                        {s.pill}
                      </span>
                    )}
                    <div className="mt-5 flex items-start gap-6">
                      <div className="font-display italic text-teal/70 leading-none" style={{ fontSize: "84px", fontWeight: 500 }}>
                        {s.n}
                      </div>
                      <div>
                        <h3 className="text-[24px] lg:text-[28px] font-extrabold tracking-tightish">{s.title}</h3>
                        <p className="mt-4 max-w-2xl text-mist/85 text-[16px] leading-relaxed">{s.body}</p>
                      </div>
                    </div>
                  </article>
                </Reveal>
              );
            }
            return (
              <Reveal key={s.n} delay={i * 80} className={span}>
                <article
                  className="bg-white border border-mist rounded-2xl p-9 h-full hover:-translate-y-1 hover:shadow-[0_18px_40px_-22px_rgba(10,19,40,0.18)] transition-all duration-300"
                  data-testid={`service-card-${s.n}`}
                >
                  <div className="flex items-start gap-5">
                    <div className="font-display italic text-blue leading-none" style={{ fontSize: "64px", fontWeight: 500 }}>
                      {s.n}
                    </div>
                    <div>
                      <h3 className="text-navy text-[20px] font-bold">{s.title}</h3>
                      <p className="mt-3 text-slate text-[15px] leading-relaxed">{s.body}</p>
                    </div>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
